import React from "react"
import { BlockedPasswordLockModal } from "./BlockedPasswordLockModal"
import { LastTryPasswordLockModal } from "./LastTryPasswordLockModal"
import { DefaultPasswordLockModal } from "./DefaultPasswordLockModal"

export function PasswordLockModalWrapper () {
  
  return (
    <>
      <DefaultPasswordLockModal />
      <LastTryPasswordLockModal />
      <BlockedPasswordLockModal />
    </>
  )
}